import { useCallback, useMemo } from 'react';
import { useAccount } from '../../contexts/account/AccountContexts';

const useCanManage = () => {
  const { accountResponse } = useAccount();

  const canManage = useMemo(
    () =>
      Boolean(
        accountResponse &&
          !['BLOCKED', 'DISABLED'].includes(accountResponse.accountStatus) &&
          accountResponse.createdMonitorCount < accountResponse.maxMonitorCount
      ),
    [accountResponse]
  );

  const checkCanManage = useCallback(async () => {
    return Boolean(
      accountResponse &&
        !['BLOCKED', 'DISABLED'].includes(accountResponse.accountStatus) &&
        accountResponse.createdMonitorCount < accountResponse.maxMonitorCount
    );
  }, [accountResponse]);

  return { canManage, checkCanManage };
};

export default useCanManage;
